// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { calendarLines16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-calendar-lines': IconCalendarLines;
    }
}

/**
 * The icon component for the 'calendarLines' icon
 */
export class IconCalendarLines extends Icon {
    public constructor() {
        super(calendarLines16X16);
    }
}

registerIcon('icon-calendar-lines', IconCalendarLines);
export const iconCalendarLinesTag = 'nimble-icon-calendar-lines';
